function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0H12V2.05493C16.1716 2.51608 19.4839 5.82838 19.9451 10H22V12H19.9451C19.4839 16.1716 16.1716 19.4839 12 19.9451V22H10V19.9451C5.82838 19.4839 2.51608 16.1716 2.05493 12H0V10H2.05493C2.51608 5.82838 5.82838 2.51608 10 2.05493V0ZM10 4.07089C6.93431 4.5094 4.5094 6.93431 4.07089 10H7V12H4.07089C4.5094 15.0657 6.93431 17.4906 10 17.9291V15H12V17.9291C15.0657 17.4906 17.4906 15.0657 17.9291 12H15V10H17.9291C17.4906 6.93431 15.0657 4.5094 12 4.07089V7H10V4.07089Z"
});

var SvgYourLocationIcon = function SvgYourLocationIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYourLocationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/your-location-icon.603853c9.svg";
export { ForwardRef as ReactComponent };